export function getMessages ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/messages', { params: { page: page } })
      .then((response) => {
        if (response.data.messages) {
          commit('setMessages', response.data.messages)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getMessage ({ state, commit }, messageId) {
  return new Promise((resolve, reject) => {
    if (messageId) {
      axiosInstance.get('/v1/messages/' + messageId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No message id'))
    }
  })
}

export function getCreateMessage ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/messages/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createMessage ({ state, commit }, { subject, message, channel, tip_mesaj, promoid, date_to_send, date_expire, warehouse, client_key }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/messages', { subject, message, channel, tip_mesaj, promoid, date_to_send, date_expire, warehouse, client_key })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditMessage ({ state, commit }, messageId) {
  return new Promise((resolve, reject) => {
    if (messageId) {
      axiosInstance.get('/v1/messages/' + messageId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No message id'))
    }
  })
}

/* eslint-disable-next-line */
export function editMessage ({ state, commit }, { id, subject, message, channel, tip_mesaj, promoid, date_to_send, date_expire, warehouse, client_key }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/messages/' + id, { subject, message, channel, tip_mesaj, date_to_send, date_expire, warehouse, client_key })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No message id'))
    }
  })
}

export function deleteMessage ({ state, commit }, messageId) {
  return new Promise((resolve, reject) => {
    if (messageId) {
      axiosInstance.delete('/v1/messages/' + messageId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No message id'))
    }
  })
}

export function resetMessageViews ({ state, commit }, messageId) {
  return new Promise((resolve, reject) => {
    if (messageId) {
      axiosInstance.post('/v1/messages/' + messageId + '/resetviews')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No message id'))
    }
  })
}
